module.exports = __webpack_public_path__ + "static/media/hardware_wallet_6.419cbebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/hardware_wallet_6.jpg
// module id = 1500
// module chunks = 0